import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {toast} from "react-toastify";
import NumericFunction from "../../../../utils/NumericFunction";

const GetInitialData = async (setInitialData, setIsLoad, sendData, setSendData, id, copyPkValue) => {

  const options = {year: 'numeric', month: '2-digit', day: '2-digit', calendar: 'persian'};
  const todayDate = new Date().toLocaleDateString('fa-IR', options);

  const now = new Date();
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');

  const pageData = await _axios.get(prefixUrl() + "/accountingDocument/?request=documentPageData2")
  if (pageData?.data?.status) {
    setInitialData({
      pageData: pageData?.data,
    });
    if (id) {
      const response = await _axios.get(prefixUrl() + "/accountingDocument/?request=documentData&documentCode=" + id)
      if (response?.data?.status) {
        setSendData({...sendData, ...response?.data?.documentData})
        setIsLoad(true);
      } else {
        toast.error(response?.data?.message)
      }
    } else if (copyPkValue) {
      const responseCopy = await _axios.get(prefixUrl() + "/accountingDocument/?request=documentData&documentCode=" + copyPkValue)
      if (responseCopy?.data?.status) {
        const newDocumentCode = await _axios.get(prefixUrl() + "/accountingDocument/?request=newDocumentCode")
        if (newDocumentCode?.data?.status) {
          setSendData({
            ...sendData,
            ...responseCopy?.data?.documentData,
            mode: "add",
            documentCode: newDocumentCode?.data?.data
          })
          setIsLoad(true);
        }
      } else {
        toast.error(responseCopy?.data?.message)
      }
    } else {
      setSendData({
        ...sendData,
        documentCode: pageData?.data.id[pageData?.data.id.length - 1],
        documentDate: NumericFunction.p2e(todayDate),
        documentTime: `${hours}:${minutes}:${seconds}`,
      })
      setIsLoad(true);
    }
  } else {
    toast.error(pageData?.data?.message)
  }
};

export default GetInitialData;